angular.module('env.data.repos.operations', [])

    .service("operationsRepository", function (rest) {
        var _this = this;

        /**
         * Get operations
         * @returns {!Promise.<Object[]>} promise of operations collection
         */
        _this.getOperations = function () {
            return rest.map("operations").get();
        };

        return _this;
    })

;